<template>
  <div class="login">
    <canvas id="three"></canvas>
  </div>
</template>

<script>
import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { OBJLoader } from "three/examples/jsm/loaders/OBJLoader";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";

export default {
  name: "Login",
  data() {
    return {};
  },
  mounted() {
    let aa = "https://onekit.cn/examples/safa/1/index.glb";
    let bb = "http://flive.oss-cn-shanghai.aliyuncs.com/qxwx/1694157611196.glb";
    let cc = this.$route.query.url?decodeURIComponent(this.$route.query.url):"http://flive.oss-cn-shanghai.aliyuncs.com/qxwx/1694157780573.obj";
    this.initThree(cc);
    // this.initThree(bb);
  },
  methods: {
    initThree(url) {
      // 创建一个场景
      const scene = new THREE.Scene();
      // 给场景添加颜色
      scene.background = new THREE.Color("#eeeee");
      // 增加雾化效果 参数1 雾化颜色 参数2
      // scene.fog = new THREE.Fog("#eee", 20, 50);

      const canvas = document.querySelector("#three");
      // 将画布元素添加到渲染器中
      const renderer = new THREE.WebGLRenderer({ canvas, antialias: true });
      // 开起渲染器阴影效果
      renderer.shadowMap.enabled = true;
      // 添加照相机
      const camera = new THREE.PerspectiveCamera(
        50,
        window.innerWidth / window.innerHeight,
        0.1,
        1000
      );
      // 移动照相位置 （照相机最初位置在原点）
      camera.position.z = 10;
      camera.position.y = 1;
      var loader = "";

      console.log('创建模型加载器obj',url,url.indexOf(".obj"))

      if (url.indexOf(".glb") != -1) {
        // 创建模型加载器
        loader = new GLTFLoader();
        // 加载模型
        loader.load(
          url,
          (gltf) => {
            let model = gltf.scene;
            scene.add(model);
          },
          () => {
            // console.log(e)
          },
          (err) => {
            console.log(err);
          }
        );
      } else if (url.indexOf(".obj") != -1) {
        // 创建模型加载器
        loader = new OBJLoader();
        // 加载模型
        loader.load(
          url,
          (gltf) => {
            scene.add(gltf);
          },
          () => {
            // console.log(e)
          },
          (err) => {
            console.log(err);
          }
        );
      }

      // 环境光源
      const hemLight = new THREE.HemisphereLight(0xffffff, 0xffffff, 0.6);
      hemLight.position.set(0, 48, 0);
      scene.add(hemLight);

      // 平行光源
      const dirLight = new THREE.DirectionalLight(0xffffff, 0.6);
      //光源等位置
      dirLight.position.set(-10, 8, -5);
      //可以产生阴影
      dirLight.castShadow = true;
      dirLight.shadow.mapSize = new THREE.Vector2(1024, 1024);
      scene.add(dirLight);

      // // 二维平面几何体
      // let floorGeometry = new THREE.PlaneGeometry(8000, 8000);
      // // 创建材质
      // let floorMaterial = new THREE.MeshPhongMaterial({
      //   color: 0x857ebb,
      //   shininess: 0,
      // });
      // // 生成网格
      // let floor = new THREE.Mesh(floorGeometry, floorMaterial);
      // floor.rotation.x = -0.5 * Math.PI;
      // floor.receiveShadow = true;
      // floor.position.y = -0.005;
      // scene.add(floor);

      // 相机控件OrbitControls.js可以对Threejs的三维场景进行缩放、平移、旋转操作，本质上改变的并不是场景，而是相机的参数
      const controls = new OrbitControls(camera, renderer.domElement);
      controls.enableDamping = true;
      controls.minPolarAngle = 0;
      controls.maxPolarAngle = Math.PI;

      // // 上下旋转范围
      // controls.minPolarAngle = 0;
      // controls.maxPolarAngle = Math.PI;
      // // 左右旋转范围
      // controls.minAzimuthAngle = -Math.PI * (100 / 180);
      // controls.maxAzimuthAngle = Math.PI * (100 / 180);
      function animate() {
        // 更新控制器
        controls.update();
        renderer.render(scene, camera);
        requestAnimationFrame(animate);

        if (resizeRendererToDisplaySize(renderer)) {
          const canvas = renderer.domElement;
          camera.aspect = canvas.clientWidth / canvas.clientHeight;
          // 更新场景的渲染
          camera.updateProjectionMatrix();
        }
      }
      animate();

      // 原因是设备的物理像素分辨率与CSS像素分辨率的比值的问题，我们的canvas绘制出来后图片因为高清屏设备的影响，导致图片变大，然而我们在浏览器的渲染窗口并没有变大，因此图片会挤压缩放使得canvas画布会变得模糊。
      function resizeRendererToDisplaySize(renderer) {
        const canvas = renderer.domElement;
        var width = window.innerWidth;
        var height = window.innerHeight;
        // devicePixelRatio此属性返回当前显示设备的物理像素分辨率与CSS像素分辨率的比值。该值也可以被解释为像素大小的比例：即一个CSS像素的大小相对于一个物理像素的大小的比值。
        var canvasPixelWidth = canvas.width / window.devicePixelRatio;
        var canvasPixelHeight = canvas.height / window.devicePixelRatio;

        const needResize =
          canvasPixelWidth !== width || canvasPixelHeight !== height;
        if (needResize) {
          renderer.setSize(width, height, false);
        }
        return needResize;
      }
    },
  },
};
</script>

<style lang="scss">
#three {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
}
</style>
